import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: LucideIcon
    title: string
    description?: string
    action?: ReactNode
    className?: string
}

const EmptyState: FC<EmptyStateProps> = ({ icon: Icon, title, description, action, className }): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center justify-center rounded-2xl border border-dashed border-border bg-card/60 px-6 py-14 text-center', className)}>
            <span className='mb-4 flex size-14 items-center justify-center rounded-full bg-muted text-muted-foreground'>
                <Icon className='size-6' aria-hidden='true' />
            </span>

            <h3 className='text-base font-bold'>
                {title}
            </h3>

            {description && (
                <p className='mt-1.5 max-w-sm text-sm leading-7 text-muted-foreground'>
                    {description}
                </p>
            )}

            {action && (
                <div className='mt-5'>
                    {action}
                </div>
            )}
        </div>
    )
}

export default EmptyState
